/**
 * Determines whether a map key entry represents a POI (Point of Interest) key.
 *
 * Relies only on reliable discriminators: category name, explicit POI ID fields,
 * and membership in the provided category name map. Fields like `pinType`,
 * `iconName`, and `logoUrl` are intentionally excluded as they can legitimately
 * exist on non-POI keys and would cause false positives.
 */
export const isPOIKey = (
  item: {
    category?: string;
    referenceId?: string;
    pinType?: string;
    iconName?: string;
    logoUrl?: string;
    label: string;
  },
  categoryNameMap: Map<string, unknown>,
): boolean => {
  const normalizedCategory = item.category?.toUpperCase().replace(/[^A-Z]/g, "");
  const normalizedLabel = item.label?.trim().toLowerCase();
  return (
    normalizedCategory === "POI" ||
    normalizedCategory === "POINTOFINTEREST" ||
    normalizedCategory?.includes("POI") ||
    !!item.referenceId ||
    (normalizedLabel ? categoryNameMap.has(normalizedLabel) : false)
  );
};
